import { api } from './client';
import { getDemoSessionId } from '../demoSession';

/**
 * Demo-mode analytics API — no auth, anonymous session id.
 * Fire-and-forget; never throw to callers.
 */
export const demoApi = {
  getKaraoke: (resourceType, text) =>
    api.post('/demo/karaoke', { resourceType, text }),

  // Admin-only: force-regenerate a clip and persist it for repo sync. Gated
  // server-side by the demo_admin_session cookie (401 otherwise).
  regenerateKaraoke: (resourceType, text) =>
    api.post('/demo/karaoke/regenerate', { resourceType, text }),

  // Warm the client karaoke cache with already-generated clips (no generation).
  prefetchKaraoke: (texts) =>
    api.post('/demo/karaoke/prefetch', { texts }),

  trackInteraction: (eventType, { word, storyId, metadata } = {}) => {
    const session_id = getDemoSessionId();
    if (!session_id) return Promise.resolve({ success: false });
    return api
      .post('/demo/track-interaction', {
        session_id,
        event_type: eventType,
        word,
        story_id: storyId,
        metadata,
      })
      .catch(() => ({ success: false }));
  },
};
